import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
	root: {
		padding: 0,
		backgroundColor: '#f6f8fa',
		height: '100%',
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
	},
	kpiRow: {
		display: 'flex',
		gap: theme.spacing(2),
		padding: theme.spacing(1.5, 2),
		marginBottom: theme.spacing(1),
		flexWrap: 'wrap',
		flexShrink: 0,
	},
	kpiCard: {
		flex: '1 1 180px',
		minWidth: 160,
		padding: theme.spacing(1.5, 2),
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
		backgroundColor: '#fff',
		borderRadius: 8,
	},
	kpiIcon: {
		width: 44,
		height: 44,
		backgroundColor: '#5c6bc0',
		color: '#fff',
		marginRight: theme.spacing(1.5),
		flexShrink: 0,
	},
	kpiTextWrap: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'center',
		minWidth: 0,
		flex: 1,
	},
	kpiValue: {
		fontWeight: 700,
		fontSize: '1.5rem',
		color: theme.palette.text.primary,
		lineHeight: 1.2,
	},
	kpiLabel: {
		color: theme.palette.text.secondary,
		fontSize: '0.8125rem',
		marginBottom: 2,
	},
	filterBar: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1.5),
		flexWrap: 'wrap',
	},
	filterBarWrap: {
		padding: theme.spacing(1, 2),
		marginBottom: theme.spacing(1),
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(2),
		backgroundColor: '#fff',
		boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
		borderRadius: 8,
		flexShrink: 0,
	},
	// User and Date filters: same outer look (outlined, same size) before and after selection
	filterControl: {
		minWidth: 150,
		'& .MuiInputBase-root': { fontSize: '12px' },
		'& .MuiOutlinedInput-input': { padding: '10px 14px' },
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#D5D6DD !important',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#303F9F !important',
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#3F51B5 !important',
		},
	},
	searchTypeSelect: {
		minWidth: 88,
		'& .MuiInputBase-root': { fontSize: '0.8125rem' },
		'& .MuiOutlinedInput-input': { padding: '6px 10px' },
	},
	searchField: {
		minWidth: 120,
		'& .MuiInputBase-root': { fontSize: '0.8125rem' },
		'& .MuiOutlinedInput-input': { padding: '6px 10px' },
	},
	mainContent: {
		display: 'flex',
		gap: theme.spacing(2),
		flex: 1,
		minHeight: 0,
		overflow: 'hidden',
		flexWrap: 'nowrap',
		padding: theme.spacing(0, 2, 2),
	},
	sessionsPanel: {
		flex: '0 1 260px',
		minWidth: 220,
		maxWidth: 280,
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		backgroundColor: '#fff',
		boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
		borderRadius: 10,
		border: '1px solid #e8ecf1',
	},
	sessionsHeader: {
		padding: theme.spacing(1.25, 2),
		flexShrink: 0,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderBottom: '1px solid #e8ecf1',
		fontWeight: 600,
		fontSize: '0.9375rem',
		color: theme.palette.text.primary,
		backgroundColor: '#fafbfc',
		borderRadius: '10px 10px 0 0',
	},
	sessionsList: {
		flex: 1,
		minHeight: 0,
		overflow: 'auto',
		WebkitOverflowScrolling: 'touch',
		padding: theme.spacing(1),
	},
	sessionItem: {
		borderRadius: 8,
		margin: theme.spacing(0.25, 0),
		padding: theme.spacing(1, 1.25),
		cursor: 'pointer',
		minHeight: 'auto',
		border: '1px solid #e8ecf1',
		backgroundColor: '#fff',
		transition: 'background-color 0.15s ease, border-color 0.15s ease',
		'&:hover': { backgroundColor: '#f8f9fb', borderColor: '#e0e4ea' },
		'&.selected': {
			backgroundColor: '#f0f4fc',
			borderLeft: '4px solid #5c6bc0',
			borderColor: '#e0e4ea',
			marginLeft: 0,
			paddingLeft: theme.spacing(1.5),
			borderRadius: '0 8px 8px 0',
			boxShadow: '0 1px 3px rgba(92,107,192,0.08)',
		},
	},
	sessionMeta: {
		fontSize: '0.75rem',
		color: theme.palette.text.secondary,
		marginTop: 4,
		display: 'flex',
		alignItems: 'center',
		gap: 4,
	},
	avatarSession: {
		backgroundColor: '#6b7280',
		color: '#fff',
		fontSize: '0.8125rem',
		fontWeight: 600,
		width: 36,
		height: 36,
	},
	activityPanel: {
		flex: '1 1 400px',
		minWidth: 320,
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		backgroundColor: '#fff',
		boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
		borderRadius: 10,
		border: '1px solid #e8ecf1',
	},
	activityHeader: {
		padding: theme.spacing(1.25, 2),
		flexShrink: 0,
		borderBottom: '1px solid #e8ecf1',
		backgroundColor: '#fafbfc',
		borderRadius: '10px 10px 0 0',
	},
	activityHeaderRow: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: theme.spacing(2),
	},
	sectionTitle: {
		fontWeight: 600,
		fontSize: '0.9375rem',
		color: theme.palette.text.primary,
	},
	activityTitle: {
		fontWeight: 600,
		fontSize: '0.9375rem',
		color: theme.palette.text.primary,
		marginRight: theme.spacing(1),
		marginBottom: 0,
	},
	tabs: {
		minHeight: 36,
		marginTop: 0,
		minWidth: 0,
		'& .MuiTab-root': { minHeight: 36, minWidth: 'auto', paddingLeft: theme.spacing(1.5), paddingRight: theme.spacing(1.5), fontSize: '0.8125rem', textTransform: 'none', fontWeight: 500 },
		'& .MuiTabs-indicator': { backgroundColor: '#5c6bc0', height: 2 },
		'& .MuiTab-textColorPrimary.Mui-selected': { color: '#5c6bc0', fontWeight: 600 },
	},
	tabLabel: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 6,
	},
	tabIcon: {
		fontSize: 14,
		display: 'block',
	},
	sessionTimeLabel: {
		fontSize: '0.75rem',
		color: theme.palette.text.secondary,
		marginTop: theme.spacing(0.5),
	},
	activityBody: {
		padding: theme.spacing(2, 2, 2, 12),
		flex: 1,
		minHeight: 0,
		overflow: 'auto',
		WebkitOverflowScrolling: 'touch',
		backgroundColor: '#fafbfc',
	},
	timeline: {
		position: 'relative',
		marginLeft: 0,
		paddingLeft: 0,
		'&::before': {
			content: '""',
			position: 'absolute',
			left: 129,
			top: 0,
			bottom: 0,
			width: 2,
			backgroundColor: '#e8ecf1',
			zIndex: 0,
		},
	},
	timelineItem: {
		position: 'relative',
		zIndex: 1,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: theme.spacing(1.5),
		marginBottom: theme.spacing(2),
		minHeight: 24,
	},
	timelineItemSuccess: {
		'& $timelineDot': { backgroundColor: '#22c55e', width: 10, height: 10, outline: '2px solid #22c55e' },
	},
	timelineItemError: {
		'& $timelineDot': { backgroundColor: theme.palette.error.main, outline: `2px solid ${theme.palette.error.main}` },
	},
	timelineItemPage: {
		alignItems: 'flex-start',
		'& $timelineDotWrap': {
			marginTop: 5,
		},
	},
	timelineItemBranch: {
		alignItems: 'flex-start',
		'& $timelineDotWrap': {
			marginTop: 5,
		},
	},
	timelineTimeCol: {
		flex: '0 0 110px',
		width: 110,
		minWidth: 110,
		fontSize: '0.75rem',
		color: theme.palette.text.secondary,
		textAlign: 'right',
		fontWeight: 500,
		whiteSpace: 'nowrap',
		lineHeight: 1.35,
		paddingRight: theme.spacing(0),
	},
	timelineDotWrap: {
		flex: '0 0 16px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	timelineDot: {
		width: 8,
		height: 8,
		borderRadius: '50%',
		backgroundColor: '#5c6bc0',
		boxShadow: '0 0 0 2px #fff',
		outline: '2px solid #5c6bc0',
	},
	timelineNodeCol: {
		flex: '1 1 auto',
		minWidth: 0,
		paddingLeft: theme.spacing(0.5),
	},
	pageTag: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 6,
		padding: '6px 14px',
		backgroundColor: '#5c6bc0',
		color: '#fff',
		borderRadius: 20,
		marginBottom: theme.spacing(1),
		fontSize: '0.8125rem',
		fontWeight: 500,
		boxShadow: '0 1px 3px rgba(92,107,192,0.25)',
	},
	actionItem: {
		fontSize: '0.8125rem',
		color: theme.palette.text.primary,
		paddingLeft: theme.spacing(2),
		marginBottom: 6,
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		lineHeight: 1.4,
	},
	dot: {
		width: 5,
		height: 5,
		borderRadius: '50%',
		backgroundColor: '#64748b',
		flexShrink: 0,
	},
	documentTag: {
		fontSize: '0.8rem',
		color: theme.palette.text.secondary,
		marginTop: 4,
		marginBottom: theme.spacing(1),
		paddingLeft: theme.spacing(2),
		fontStyle: 'italic',
	},
	timelineBranch: {
		marginLeft: theme.spacing(3),
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		paddingLeft: theme.spacing(2),
		borderLeft: `1px dashed ${theme.palette.divider}`,
	},
	destartButton: {
		display: 'inline-flex',
		alignItems: 'center',
		padding: '4px 12px',
		marginBottom: theme.spacing(1),
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
		borderRadius: theme.shape.borderRadius,
		fontSize: '0.85rem',
		fontWeight: 500,
		cursor: 'pointer',
		border: 'none',
	},
	filterLabel: {
		fontSize: '0.875rem',
		color: theme.palette.text.secondary,
		marginRight: theme.spacing(1),
		alignSelf: 'center',
	},
}));
